// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.0-beta.1629e6a57',
  revision: '1629e6a57',
  branch: 'develop',
  date: 'Mon, 24 Aug 2026 16:58:40 GMT'
};